export const SELECTED_ALL = 'all';
